import styled from "styled-components";

export const CheckboxButtonsStyles = styled.div`
  display: flex;
  align-items: center;

  .checkboxButton {
    background: ${({ theme }) => theme.colors.semantic.container.white};
    border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
    border-radius: ${({ theme }) => theme.radius[4]};
    font-style: normal;
    font-weight: ${({ theme }) => theme.typography.title.t2.weight};
    font-size: ${({ theme }) => theme.typography.body.b2.size};
    line-height: ${({ theme }) => theme.typography.body.b2.lineHeight};
    text-align: center;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    padding: ${({ theme }) => theme.spacing[4]} ${({ theme }) => theme.spacing[8]};
    min-width: 45px;
    height: 28px;
    margin-right: ${({ theme }) => theme.spacing[12]};
    cursor: pointer;
  }

  .active {
    background: ${({ theme }) => theme.colors.primary[100]};
    border: 1px solid ${({ theme }) => theme.colors.semantic.text.strong};
  }
`;
